// extracted by mini-css-extract-plugin
export default {"backdrop":"VideoUploadModal_backdrop__nUqPd","modal":"VideoUploadModal_modal__bRR0U","closeBtn":"VideoUploadModal_closeBtn__Ss2et","actions":"VideoUploadModal_actions__oJTLp"};